// extracted by mini-css-extract-plugin
export default {"inheritColor":"styles-module__inheritColor--fDWem","TableRowHeading":"styles-module__TableRowHeading--B4EmQ","TableRowSubheading":"styles-module__TableRowSubheading--P3KLV"};